module.exports = __webpack_public_path__ + "static/media/icon-filter.4c278baa.svg";